import { gettext } from '@eventbrite/i18n';

export const MAKE_SURE_YOU_GET_PAID = gettext('Make sure you get paid');
export const SET_UP_YOUR_ACCOUNT = gettext(
    'Finish setting up your account to receive funds for your events.',
);
export const ADD_FINANCIAL_INFO_TO_GET_PAID = gettext(
    'Add your financial information to receive funds from your event',
);
export const ADD_BANK_INFO_TO_GET_PAID = gettext(
    'Set your bank account to receive funds from your event',
);
export const ADD_FINANCIAL_INFO = gettext('Add financial information');
export const ADD_BANK_ACCOUNT = gettext('Add a bank account');
export const COMPLETE_TAX_PAYER_INFORMATION = gettext(
    'Complete taxpayer information',
);
export const FILL_OUT_TAX_INFORMATION = gettext('Fill out tax information');
export const TITLE_PAYOUTS_FROZEN = gettext('Your payouts are frozen');
